import React from "react";
import "./Footer.css";
import flogo from './footer img.png'
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
    <div className="footer-top">
      <div className="footer-left">
        <h5>Download Catalogue</h5>
        <img src={flogo}/>
        <li>Industrial Conveyor Chains</li>
        <li>Industrial Transmission Chains</li>
      </div>
      <div className="footer-middle">
        <h5>Address</h5>
        <p className="addr">
          Swajit Engineering Private Ltd.<br></br>
          K-9, M.I.D.C. Waluj.<br></br>
          Aurangabad-431136<br></br>
          (M.S) India.<br></br>
          Phone: +91-240-2555031, 2554531<br></br>
          Mobile: +91-99-2294-1689<br></br>
          Skype: sandesh.borade<br></br>
          Fax: +91-240-2555032<br></br>
          Email: marketing@swajit.com<br></br>
        </p>
      </div>
      <div className="footer-right">
        <h5>Location</h5>
        <div class="mapouter"><div class="gmap_canvas"><iframe class="gmap_iframe" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=436&amp;height=240&amp;hl=en&amp;q=swajit engineering&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe><a href="https://sprunkiphasez.com/"></a></div><style> </style></div>
      </div>
      </div>

      <hr className="line"/>

      <div className="footer-bottom">
        <div className="footer-bottom-one">
        &copy;2025 Powered by MK e-Tech Pvt. Ltd.
        </div>
        <div className="footer-bottom-two">
            <ul className="footer-item">
                <Link to="/site"><li className="site">Sitemap</li></Link>
                <Link to="/home"><li>Home</li></Link>
                <Link to="/about"><li>Corporate</li></Link>
                <Link to="/product"><li>Products</li></Link>
                <Link to="/photogalary"><li>Photo Gallery</li></Link>
                <Link to="/infrastructure"><li>Resources</li></Link>
                <Link to="/career"><li>Careers</li></Link>
                <Link to="/csr"><li>CSR</li></Link>
                <Link to="/sugar"><li>Application Videos</li></Link>
                <Link to="/feedback"><li>Feedback</li></Link>
                <Link to="/download"><li>Download</li></Link>
                <Link to="/contact"><li>Contact Us</li></Link>
            </ul>
        </div>
        
      </div>
    </div>
  );
};

export default Footer;
